<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="select" label="所属类目" name="product_type_id" options="PRODUCT_CLASSIFY"></c-form-item>
					<c-form-item type="input" label="属性名称" name="parameter_name"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_product_attr_add" color="sys" @click="add">新增商品属性</c-button>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="属性名称"
					name="parameter_name"
          width="150"
        ></c-table-column>

        <c-table-column
            label="是否必填"
            name="required_flag"
            width="80"
        >
          <template v-slot="{data}">
            <span style="color:gray" v-if="data.required_flag==1">非必填</span>
            <span style="color:green" v-if="data.required_flag==2">必填</span>
          </template>
        </c-table-column>

        <c-table-column
            label="是否展示"
            name="is_display"
            width="80"
        >
          <template v-slot="{data}">
            <span style="color:gray" v-if="data.is_display==1">隐藏</span>
            <span style="color:green" v-if="data.is_display==2">展示</span>
          </template>
        </c-table-column>

        <c-table-column
            label="可搜索"
            name="is_search"
            width="80"
        >
          <template v-slot="{data}">
            <span style="color:gray" v-if="data.is_search==1">{{data.parameter_type == 'text' ? '--' :'不可搜索'}}</span>
            <span style="color:green" v-if="data.is_search==2">可搜索</span>
          </template>
        </c-table-column>

				<c-table-column
					label="属性类型"
					name="parameter_type"
          width="80"
        >
					<template v-slot="{data}">
					{{paramTypeMap[data.parameter_type]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="属性值"
					name="parameter_values"
          width="300"
        ></c-table-column>
				
				<c-table-column
					label="所属类目"
					name="type_full_name"
          width="200"
        ></c-table-column>

				<c-table-column
					type="sort"
					label="排序"
					power="b_product_param_sort"
					@sort="sortHandle"
          width="80"
        ></c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="120"
				>
					<template v-slot="{data}">
						<c-table-button power="b_product_attr_edit" @click="edit(data)">编辑</c-table-button>
						<c-table-button power="b_product_attr_del" @click="del(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="editDialog" :title="editState ? '编辑商品属性' : '新增商品属性'" width="600" @resolve="submit">
			<c-form ref="editForm">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item type="hidden" name="type" value="2"></c-form-item>
				<c-form-item type="input" label="属性名称" name="parameter_name" required></c-form-item>
				<c-form-item v-model="paramType" type="select" label="属性类型" name="parameter_type" :options="paramTypeOptions" required></c-form-item>
				<c-form-item v-show="paramType != 'text'" type="textarea" label="属性值" name="parameter_values" required word="使用“英文逗号”分隔" :inline-word="false"></c-form-item>
				<c-form-item type="select" label="所属类目" name="product_type_id" options="PRODUCT_CLASSIFY" required></c-form-item>
				<c-form-item type="radio" label="是否必填" name="required_flag" :options="requiredOptions" required></c-form-item>
                <c-form-item type="radio" label="是否展示" name="is_display" :options="requiredOptions"></c-form-item>
                <c-form-item type="radio" v-if="paramType != 'text'" label="是否可搜索" name="is_search" :options="requiredOptions" required></c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'm_product_attr',
		
		data() {
			return {
				paramType: '',
				paramTypeOptions: [{
					name: '文本框',
					value: 'text'
				}, {
					name: '下拉框',
					value: 'select'
				}, {
					name: '单选框',
					value: 'radio'
				}, {
					name: '复选框',
					value: 'checkbox'
				}],

				paramTypeMap:{'text': '文本框','select': '下拉框','radio': '单选框','checkbox': '复选框'},

				requiredOptions: [{
					name: '是',
					value: 2
				}, {
					name: '否',
					value: 1
				}],
				
				editState: false
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				data.type = 2;
				this.$refs.table.load({
					url: '/product_param/list',
					data
				});
			},
			
			add() {
				this.editState = false;
				this.$refs.editForm.clear();
				this.$refs.editForm.set({type:2,parameter_type:'select',required_flag:1});
				this.$refs.editDialog.open();
			},
			
			edit(val) {
				this.editState = true;
				this.$refs.editForm.set(val);
				this.$refs.editDialog.open();
			},

			del(val) {
				this.$confirm({
					text: '确定要删除【'+val.parameter_name+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/product_param/remove',
							data: {type:2,id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			sortHandle(row, type, next) {
				//row.prev() 上一行数据
				//row.next() 下一行数据
				let submitData ={};
				submitData.type = 2
				if(type=='top' || type=='bottom'){
					submitData.sort_type = type;
					submitData.id = row.data.id;
				}
				if(type=='up'){
					submitData.id1 = row.data.id;
					submitData.id2 = row.prev().data.id;
				}
				if(type=='down'){
					submitData.id1 = row.data.id;
					submitData.id2 = row.next().data.id;
				}
				this.request({
					url: '/product_param/sort',
					data: submitData,
					loading: true,
					success: data => {
						next();
					}
				});
			},

			submit(stop) {
				stop();
				this.$refs.editForm.submit({
					url: this.editState ? '/product_param/edit' : '/product_param/add',
					rule: {
						parameter_name: '请填写属性名称',
						parameter_type: '请选择属性类型',
						parameter_values: [{
							type: 'empty',
							word: '请填写属性值',
							skip: data => {
								return data.parameter_type == 'text';
							}
						}],
						product_type_id: '请选择所属类目',
						required_flag: '请选择是否必填',
                        is_search: [{
                            type: 'empty',
                            word: '请选择是否可搜索',
                            skip: data => {
                                return data.parameter_type == 'text';
                            }
                        }],
					},
					success: (data, res) => {
						this.$message({
							text: '保存成功'
						});
						this.$refs.table.update();
						this.$refs.editDialog.close();
					}
				});
			}
		}
	}
</script>